import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap-5';

import SearchInput from './search_input';
import SelectedItems from './selected_items';
import { Button } from 'components/ui/button';

class SelectionModal extends React.Component {
  static propTypes = {
    itemLabel: PropTypes.string.isRequired,
    limit: PropTypes.number,
    modalTitle: PropTypes.string,
    queryKey: PropTypes.string.isRequired,
    renderItem: PropTypes.func.isRequired,
    searchParams: PropTypes.object,
    searchPath: PropTypes.string.isRequired,
    searchPlaceholder: PropTypes.string,
    selectedItems: PropTypes.array.isRequired,
    show: PropTypes.bool,

    onCancel: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired
  }

  state = {
    selectedItems: this.props.selectedItems
  }

  componentDidUpdate(previousProps) {
    if (this.props.show && !previousProps.show) {
      this.setState({ selectedItems: this.props.selectedItems });
    }
  }

  canAddItems = () => {
    const { limit } = this.props;
    const { selectedItems } = this.state;

    return !limit || limit < 1 || selectedItems.length < limit;
  };

  handleSelect = (item) => {
    this.setState(({ selectedItems }) => ({
      selectedItems: selectedItems.concat(item)
    }));
  }

  handleDeselect = (item) => {
    this.setState(({ selectedItems }) => ({
      selectedItems: selectedItems.filter(selectedItem => selectedItem.id !== item.id)
    }));
  }

  handleOk = () => {
    this.props.onOk(this.state.selectedItems || []);
  }

  render() {
    const modalTitle = this.props.modalTitle || `Select ${this.props.itemLabel}`;

    return (
      <Modal
        backdrop="static"
        centered
        className="selection-modal"
        keyboard={false}
        show={this.props.show}
        onHide={this.props.onCancel}
      >
        <Modal.Header closeButton>
          <h6>{modalTitle}</h6>
        </Modal.Header>

        <Modal.Body className="d-flex flex-column gap-4">
          <SearchInput
            disabled={!this.canAddItems()}
            excludedItems={this.state.selectedItems}
            itemLabel={this.props.itemLabel}
            queryKey={this.props.queryKey}
            renderItem={this.props.renderItem}
            searchParams={this.props.searchParams}
            searchPath={this.props.searchPath}
            searchPlaceholder={this.props.searchPlaceholder}
            show={this.props.show}
            onSelect={this.handleSelect}
          />

          <SelectedItems
            itemLabel={this.props.itemLabel}
            items={this.state.selectedItems}
            renderItem={this.props.renderItem}
            onDeselect={this.handleDeselect}
          />
        </Modal.Body>

        <Modal.Footer>
          <div className="text-end">
            <Button label="Cancel" name="cancel" variant="ghost" onClick={this.props.onCancel} />
            <Button label="OK" name="ok" onClick={this.handleOk} />
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default SelectionModal;
